import { Link } from "react-router-dom";
import { categories, contactInfo } from "@/mocks/site";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 md:mt-24 bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-fire-fill text-xl"></i>
              </span>
              <span className="font-heading font-extrabold text-xl text-background-50">
                51<span className="text-primary-400">动漫</span>
              </span>
            </div>
            <p className="text-sm leading-relaxed text-primary-100/80 mb-4">
              海量动漫资源与最新资讯平台，为动漫爱好者提供作品信息、行业动态与阅读推荐。
            </p>
            <div className="flex items-center gap-2">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-bilibili-fill", "ri-mail-fill"].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900/60 text-primary-100 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                >
                  <i className={icon}></i>
                </span>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">
              快速导航
            </h4>
            <ul className="space-y-3 text-sm">
              {[
                { label: "首页", to: "/" },
                { label: "动漫分类", to: "/anime" },
                { label: "动漫资讯", to: "/news" },
                { label: "关于我们", to: "/about" },
                { label: "联系我们", to: "/contact" },
              ].map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-primary-100/80 hover:text-primary-400 transition-colors cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">
              热门分类
            </h4>
            <div className="flex flex-wrap gap-2">
              {categories.slice(0, 8).map((cat) => (
                <Link
                  key={cat.name}
                  to={`/anime?type=${encodeURIComponent(cat.name)}`}
                  className="px-3 py-1.5 rounded-full bg-primary-900/60 text-primary-100/90 text-xs hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">
              联系方式
            </h4>
            <ul className="space-y-3 text-sm text-primary-100/80">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <a href={`mailto:${contactInfo.email}`} className="hover:text-primary-400 transition-colors">
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>{contactInfo.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>{contactInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-900/70">
        <div className="w-full px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-100/70">
          <p>© {year} 51动漫 版权所有 · 本站内容为演示数据，仅供学习交流使用</p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="hover:text-primary-400 transition-colors cursor-pointer">
              隐私政策
            </Link>
            <Link to="/about" className="hover:text-primary-400 transition-colors cursor-pointer">
              版权声明
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}